import { Inbox, Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface EmptyStateProps {
  title: string
  description: string
  action?: {
    label: string
    onClick: () => void
  }
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="text-center py-12">
      <Inbox className="mx-auto h-12 w-12 text-muted-foreground" strokeWidth={1.5} />
      <h3 className="mt-2 text-sm font-semibold text-foreground">{title}</h3>
      <p className="mt-1 text-sm text-muted-foreground">{description}</p>
      {action && (
        <div className="mt-6">
          <Button onClick={action.onClick}>
            <Plus className="h-5 w-5" />
            {action.label}
          </Button>
        </div>
      )}
    </div>
  )
}
